import { useState } from 'react'
import { Mail } from 'lucide-react'
import ConnectGoogleButton from './ConnectGoogleButton'
import ImapConnectModal from './ImapConnectModal'

// OSPROD-MAIL-CAL-L3: rendered by MailDashboard when the user has
// zero mail-relevant accounts. Reused inside the manage-accounts UI
// via `onAdd` from AccountsManager.

interface Props {
  onConnected?: (accountId: number) => void
}

export default function ConnectMailEmptyState({ onConnected }: Props) {
  const [imapOpen, setImapOpen] = useState(false)
  return (
    <>
      <div className="flex flex-col items-center text-center gap-4 py-16">
        <div className="w-16 h-16 rounded-full bg-primary/10 text-primary flex items-center justify-center">
          <Mail size={28} />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-foreground">Connect your inbox</h2>
          <p className="text-sm text-muted-foreground mt-1 max-w-xs">
            Sign in to Gmail or add an IMAP/SMTP account. You can connect multiple accounts.
          </p>
        </div>
        <div className="flex flex-col gap-2 w-72">
          <ConnectGoogleButton module="mail" />
          <button
            type="button"
            onClick={() => setImapOpen(true)}
            className="inline-flex items-center justify-center gap-2 rounded-md border border-border bg-card px-4 py-2 text-sm font-medium text-foreground hover:bg-muted transition"
          >
            Add IMAP / SMTP
          </button>
        </div>
      </div>
      {imapOpen && (
        <ImapConnectModal
          onClose={() => setImapOpen(false)}
          onConnected={(id) => { setImapOpen(false); onConnected?.(id) }}
        />
      )}
    </>
  )
}
